import { Fragment, useContext } from "react";

import AirFooterBannerInfo from "./AirFooterBannerInfo";
import { AppContext } from "@/contexts/appContexts";
import { getCategoryBanner, getCategoryData } from "@/utils/category";
import ProductsList from "./ProductsList";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

const AirBannerInfo = ({ data, language, t, isMobile }) => {
    const { categoryData } = useContext(AppContext);
    const cat = getCategoryData(
        categoryData?.children_data,
        "id",
        data?.category_id
    );

    const imageBanner = getCategoryBanner(cat, isMobile)
    console.log({imageBanner});
    
    return (
        <>
            <h2 className="mb-2 font-bold text-[22px] max-[768px]:text-base">
                {data[`title-${language}`]}
            </h2>
            {imageBanner ? <AirFooterBannerInfo imgPath={imageBanner} /> : null}

            <ProductsList
                data={{ ...cat, id: data?.category_id }}
                isMobile={isMobile}
                t={t}
            />
            <p
                className="mt-3 mb-6 max-[768px]:text-sm"
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(data[`description-${language}`]),
                }}
            />
            {data?.q_a.map((info, i) => (
                <Fragment key={i}>
                    <h3 className="mb-2 text-lg font-bold max-[768px]:text-base">
                        {info[`question_${language}`]}
                    </h3>
                    <p className="mt-3 mb-6 max-[768px]:text-sm">
                        {info[`answer_${language}`]}
                    </p>
                </Fragment>
            ))}
        </>
    );
};

export default AirBannerInfo;
